import React from 'react'
import './App.css'
import { Link, Redirect } from 'react-router-dom'
import Axios from 'axios'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
import { IoSearch } from 'react-icons/io5'
import TopBarProgress from 'react-topbar-progress-indicator'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import { BiMenu } from 'react-icons/bi'
import { API_URL } from './config'

// Match these to your SideNav CSS widths
const SIDEBAR_WIDTH = 240
const SIDEBAR_COLLAPSED_WIDTH = 72

const C = {
  ink: '#14213d',
  muted: '#6b7590',
  line: '#e6e9f2',
  track: '#eef1f8',
  blue: '#2f6fed',
}

const AVATARS = [
  ['#e8f0ff', '#2f6fed'],
  ['#efe6fb', '#8b3fd9'],
  ['#fff1dc', '#c77d0a'],
  ['#dcf5ec', '#0e8a5c'],
  ['#fde6e7', '#d13b40'],
]

const styles = `
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap');

.cu { font-family: 'Manrope', system-ui, -apple-system, 'Segoe UI', sans-serif; color: ${C.ink}; max-width: 880px; margin: 0 auto; padding: 8px 0 48px; }
.cu *, .cu *::before, .cu *::after { box-sizing: border-box; }
.cu h1, .cu p { margin: 0; }

.cu-back { display: inline-flex; align-items: center; gap: 4px; background: none; border: 0; padding: 4px 8px 4px 0; color: ${C.muted}; font: 600 14px/1 'Manrope', sans-serif; cursor: pointer; margin-top:40px }
.cu-back:hover { color: ${C.ink}; }
.cu-back:focus-visible, .cu-row:focus-visible, .cu-search input:focus-visible { outline: 2px solid ${C.blue}; outline-offset: 2px; border-radius: 8px; }

.cu-head { display: flex; flex-wrap: wrap; align-items: flex-end; justify-content: space-between; gap: 14px; margin: 14px 0 20px; }
.cu .cu-title { font-size: 26px; font-weight: 800; letter-spacing: -0.02em; line-height: 1.15; color: ${C.ink}; text-align: left; }
.cu .cu-sub { margin-top: 4px; font-size: 14px; font-weight: 500; color: ${C.muted}; }

.cu-search { position: relative; width: 320px; max-width: 100%; }
.cu-search svg { position: absolute; left: 13px; top: 50%; transform: translateY(-50%); color: ${C.muted}; pointer-events: none; }
.cu-search input { width: 100%; height: 42px; padding: 0 14px 0 38px; border: 1px solid ${C.line}; border-radius: 10px; background: #fff; font: 500 14px 'Manrope', sans-serif; color: ${C.ink}; }
.cu-search input::placeholder { color: #9aa3b8; }

.cu-card { background: #fff; border: 1px solid ${C.line}; border-radius: 14px; overflow: hidden; }
.cu-list-h { display: flex; justify-content: space-between; padding: 12px 20px; background: #f8f9fd; border-bottom: 1px solid ${C.line}; font-size: 12.5px; font-weight: 700; color: ${C.muted}; }

.cu a.cu-row { display: flex; align-items: center; gap: 14px; padding: 14px 20px; border-bottom: 1px solid ${C.line}; color: ${C.ink}; text-decoration: none; }
.cu a.cu-row:last-child { border-bottom: 0; }
.cu a.cu-row:hover { background: #fafbfe; text-decoration: none; color: ${C.ink}; }
.cu a.cu-row:hover .cu-go { color: ${C.ink}; transform: translateX(2px); }

.cu-av { flex: 0 0 auto; width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: 800; letter-spacing: .02em; }
.cu-main { flex: 1 1 auto; min-width: 0; }
.cu-name { font-size: 14.5px; font-weight: 700; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.cu-contact { margin-top: 2px; font-size: 12.5px; font-weight: 500; color: ${C.muted}; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.cu-go { flex: 0 0 auto; color: #b4bbcd; transition: transform .15s ease, color .15s ease; }

.cu-empty { padding: 56px 16px; text-align: center; }

.cu-pager { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 12px; padding: 14px 20px; border-top: 1px solid ${C.line}; background: #f8f9fd; }
.cu-pager-info { display: flex; flex-wrap: wrap; align-items: center; gap: 16px; font-size: 13px; font-weight: 600; color: ${C.muted}; font-variant-numeric: tabular-nums; }
.cu-size { display: inline-flex; align-items: center; gap: 8px; margin: 0; font-weight: 600; }
.cu-size select { height: 30px; padding: 0 8px; border: 1px solid ${C.line}; border-radius: 8px; background: #fff; color: ${C.ink}; font: 600 13px 'Manrope', sans-serif; }
.cu-pages { display: flex; align-items: center; gap: 4px; }
.cu-pg { min-width: 32px; height: 32px; padding: 0 8px; display: inline-flex; align-items: center; justify-content: center; border: 1px solid transparent; border-radius: 8px; background: transparent; color: ${C.ink}; font: 700 13px 'Manrope', sans-serif; cursor: pointer; font-variant-numeric: tabular-nums; }
.cu-pg:hover:not(:disabled):not(.on) { background: #fff; border-color: ${C.line}; }
.cu-pg.on { background: ${C.ink}; color: #fff; }
.cu-pg:disabled { opacity: .35; cursor: not-allowed; }
.cu-pg:focus-visible, .cu-size select:focus-visible { outline: 2px solid ${C.blue}; outline-offset: 2px; }
.cu-dots { min-width: 24px; text-align: center; color: ${C.muted}; font-weight: 700; }
.cu-empty h3 { margin: 0 0 6px; font-size: 16px; font-weight: 700; }
.cu-empty p { color: ${C.muted}; font-size: 14px; }

@media (max-width: 560px) {
  .cu .cu-title { font-size: 22px; }
  .cu-search { width: 100%; }
  .cu a.cu-row { padding: 12px 14px; }
  .cu-list-h { padding: 12px 14px; }
}
@media (prefers-reduced-motion: reduce) { .cu-go { transition: none; } }
`

// 1 ... 4 5 6 ... 12 style page list
const pageList = (current, total) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1)
  const pages = new Set([1, total, current - 1, current, current + 1])
  if (current <= 3) [2, 3, 4].forEach((p) => pages.add(p))
  if (current >= total - 2) [total - 3, total - 2, total - 1].forEach((p) => pages.add(p))
  const sorted = [...pages].filter((p) => p >= 1 && p <= total).sort((a, b) => a - b)
  const out = []
  sorted.forEach((p, i) => {
    if (i > 0 && p - sorted[i - 1] > 1) out.push('...')
    out.push(p)
  })
  return out
}

const initials = (item) => {
  const a = (item.fname || '').trim().charAt(0)
  const b = (item.lname || '').trim().charAt(0)
  return (a + b).toUpperCase() || '?'
}

const avatarColors = (item) => {
  const s = `${item.fname || ''}${item.lname || ''}`
  let h = 0
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) % AVATARS.length
  return AVATARS[h]
}

class Customers extends React.Component {
  constructor(props) {
    super(props)
    const isMobile = window.innerWidth <= 768
    this.state = {
      details: [],
      query: '',
      loadBarProgress: true,
      isMobile,
      collapsed: isMobile,
      page: 1,
      pageSize: 20,
    }
  }

  componentDidMount() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)

    const businessname = localStorage.getItem('businessname')
    const accounttype = localStorage.getItem('accounttype')
    const businessid = localStorage.getItem('businessid')
    document.title = 'Customers / ' + businessname

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=CLIENTELE&subquery=GETCLIENTELE&accountid=${businessid}&accounttype=${accounttype}`,
      {
        withCredentials: true,
      },
    )
      .then((response) => {
        if (response.data.val == 0) {
          this.setState({ details: [], loadBarProgress: false })
        } else {
          this.setState({ details: response.data, loadBarProgress: false })
        }
      })
      .catch((error) => console.log(error))
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile)
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }))
  }

  searchQuery = (text) => {
    this.setState({ query: text.target.value, page: 1 })

    let query = text.target.value.split(' ').join('+')
    const accounttype = localStorage.getItem('accounttype')
    const accountid = localStorage.getItem('businessid')

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=CLIENTELE&subquery=SEARCHCLIENTELE&search=${query}&accountid=${accountid}&accounttype=${accounttype}`,
      {
        withCredentials: true,
      },
    )
      .then((response) => {
        if (response.data.val == 0) {
          this.setState({ details: [] })
        } else {
          this.setState({ details: response.data })
        }
      })
      .catch((error) => console.log(error))
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }))
  }

  totalPages = () => Math.max(1, Math.ceil(this.state.details.length / this.state.pageSize))

  currentPage = () => Math.min(this.state.page, this.totalPages())

  goToPage = (p) => {
    const next = Math.min(Math.max(p, 1), this.totalPages())
    this.setState({ page: next })
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  changePageSize = (e) => {
    this.setState({ pageSize: Number(e.target.value), page: 1 })
  }

  details = () => {
    const accounttype = localStorage.getItem('accounttype')
    const { details, query, pageSize } = this.state

    if (details.length < 1) {
      return (
        <div className="cu-empty">
          <h3>{query ? 'No matching customers' : 'No customers yet'}</h3>
          <p>
            {query
              ? 'Try a different name, phone number or email.'
              : 'Customers who buy tickets from you will appear here.'}
          </p>
        </div>
      )
    }

    const start = (this.currentPage() - 1) * pageSize
    return details.slice(start, start + pageSize).map((item, index) => {
      const [bg, fg] = avatarColors(item)
      const contact = [item.phone, item.email].filter(Boolean).join('  |  ')
      return (
        <Link
          key={item.clientid || index}
          className="cu-row"
          to={{
            pathname: '/customerprofile',
            state: {
              accountid: localStorage.getItem('businessid'),
              accounttype: accounttype,
              clientid: item.clientid,
              phone: item.phone,
              clientename: item.fname + ' ' + item.lname,
              email: item.email,
              prevpage: 'customers',
            },
          }}
        >
          <span className="cu-av" style={{ background: bg, color: fg }}>
            {initials(item)}
          </span>
          <span className="cu-main">
            <div className="cu-name">
              {item.fname} {item.lname}
            </div>
            {contact ? <div className="cu-contact">{contact}</div> : null}
          </span>
          <IoIosArrowForward className="cu-go" size={18} />
        </Link>
      )
    })
  }

  render() {
    if (localStorage.getItem('businessid') === null) {
      return <Redirect to="/login" />
    }
    const { loadBarProgress, collapsed, isMobile, details, query, pageSize } = this.state
    const totalPages = this.totalPages()
    const page = this.currentPage()
    const sidebarOffset = isMobile ? 0 : collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH

    return (
      <div className="view">
        <style>{styles}</style>
        {loadBarProgress && <TopBarProgress />}

        <Header />
        <SideNav collapsed={collapsed} onToggle={this.handleToggle} />

        {isMobile && !collapsed && (
          <div className="mobile-overlay active" onClick={this.handleToggle} />
        )}
        {isMobile && collapsed && (
          <label className="mobile-toggle" onClick={this.handleToggle}>
            <BiMenu size={25} />
          </label>
        )}

        <div
          style={{
            marginTop: 48,
            marginLeft: sidebarOffset,
            width: `calc(100% - ${sidebarOffset}px)`,
            padding: '0 16px',
            transition: 'margin-left .25s ease, width .25s ease',
          }}
        >
          <div className="cu">
            <button type="button" className="cu-back" onClick={() => this.props.history.goBack()}>
              <IoIosArrowBack size={18} />
              Back
            </button>

            <div className="cu-head">
              <div>
                <h1 className="cu-title">Customers</h1>
                <p className="cu-sub">
                  {loadBarProgress
                    ? 'Loading...'
                    : query
                      ? `${details.length} result${details.length === 1 ? '' : 's'}`
                      : `${details.length} customer${details.length === 1 ? '' : 's'}`}
                </p>
              </div>
              <label className="cu-search">
                <IoSearch size={17} />
                <input
                  type="text"
                  placeholder="Search customer"
                  value={query}
                  onChange={this.searchQuery}
                  aria-label="Search customers"
                />
              </label>
            </div>

            <div className="cu-card">
              {details.length > 0 && (
                <div className="cu-list-h">
                  <span>Name</span>
                  <span>Profile</span>
                </div>
              )}
              {this.details()}
              {details.length > 0 && (
                <div className="cu-pager">
                  <div className="cu-pager-info">
                    Showing {(page - 1) * pageSize + 1}-{Math.min(page * pageSize, details.length)}{' '}
                    of {details.length}
                    <label className="cu-size">
                      <span>Per page</span>
                      <select
                        value={pageSize}
                        onChange={this.changePageSize}
                        aria-label="Customers per page"
                      >
                        {[10, 20, 50, 100].map((n) => (
                          <option key={n} value={n}>
                            {n}
                          </option>
                        ))}
                      </select>
                    </label>
                  </div>
                  {totalPages > 1 && (
                    <nav className="cu-pages" aria-label="Pagination">
                      <button
                        type="button"
                        className="cu-pg"
                        disabled={page === 1}
                        onClick={() => this.goToPage(page - 1)}
                        aria-label="Previous page"
                      >
                        <IoIosArrowBack size={15} />
                      </button>
                      {pageList(page, totalPages).map((p, i) =>
                        p === '...' ? (
                          <span key={`e${i}`} className="cu-dots">
                            ...
                          </span>
                        ) : (
                          <button
                            key={p}
                            type="button"
                            className={`cu-pg ${p === page ? 'on' : ''}`}
                            aria-current={p === page ? 'page' : undefined}
                            onClick={() => this.goToPage(p)}
                          >
                            {p}
                          </button>
                        ),
                      )}
                      <button
                        type="button"
                        className="cu-pg"
                        disabled={page === totalPages}
                        onClick={() => this.goToPage(page + 1)}
                        aria-label="Next page"
                      >
                        <IoIosArrowForward size={15} />
                      </button>
                    </nav>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Customers
